import React, { useState } from 'react'
import { Flex, Steps } from 'antd'
import { actions } from '../../../../store/reducers/assignment.reducer'
import { connect } from 'react-redux'
import DefineFeedbackStep from './steps/DefineDescriptionStep'
import ReviewPatternStep from './steps/ReviewPatternStep'
import { getColorByIndex } from '../../../../utils/colors.helper'
import ModalWithEditor from '../file-drawer/modal-with-editor/ModalWithEditor'
import CreateSemanticPatternInstructions from './CreateSemanticPatternInstructions'

const CreateSemanticPatternModal = ({
    semanticPatternDetails,
    setSemanticPatternDetails,
    setShowSemanticPatternModal,
}) => {
    const [currentStep, setCurrentStep] = useState(0)
    const [focusedCriterion, setFocusedCriterion] = useState(null)

    const moveToNextStep = () => {
        setCurrentStep(currentStep + 1)
    }

    const handleCancel = () => {
        setShowSemanticPatternModal(false)
        setSemanticPatternDetails(null)
    }

    const stepItems = [
        { title: 'Define Description' },
        { title: 'Review Pattern' },
    ]

    const stepContents = [
        <DefineFeedbackStep key='define' moveToNextStep={moveToNextStep} />,
        <ReviewPatternStep key='review' setFocusedCriterion={setFocusedCriterion} />,
    ]

    const patternsList = semanticPatternDetails?.projection?.length
        ? semanticPatternDetails.projection.reduce((acc, p) => {
              if (p.matched_snippets) {
                  p.matched_snippets.forEach(snippet => {
                      acc.push({
                          motifId: semanticPatternDetails.id,
                          startRow: snippet.lineno,
                          endRow: snippet.end_lineno,
                          color: getColorByIndex(semanticPatternDetails?.colorId).value,
                          tooltip: `Hit by criterion: "${p.criterion}"`,
                      })
                  })
              }
              return acc
          }, [])
        : []

    let selectedSnippets
    if (focusedCriterion && semanticPatternDetails?.projection?.length) {
        const projection = semanticPatternDetails.projection.find(p => p.criterion === focusedCriterion)
        selectedSnippets =
            projection?.matched_snippets?.map(snippet => ({
                start: snippet.lineno,
                end: snippet.end_lineno,
            })) || []
    }

    return (
        <ModalWithEditor
            title={
                <Flex gap={8} align='center'>
                    Create semantic pattern
                    <CreateSemanticPatternInstructions />
                </Flex>
            }
            patternsList={patternsList}
            selectedSnippets={selectedSnippets}
            onCancel={handleCancel}
            footer={null}
            width={1200}
        >
            <Steps className='mb-32' current={currentStep} size='small' items={stepItems} />
            <div>{stepContents[currentStep]}</div>
        </ModalWithEditor>
    )
}

const mapState = ({ assignment }) => {
    return {
        semanticPatternDetails: assignment.semanticPatternDetails,
    }
}

const mapDispatch = dispatch => {
    return {
        setShowSemanticPatternModal(value) {
            dispatch(actions.setShowSemanticPatternModal(value))
        },
        setSemanticPatternDetails(value) {
            dispatch(actions.setSemanticPatternDetails(value))
        },
    }
}

export default connect(mapState, mapDispatch)(CreateSemanticPatternModal)
